import { runDays } from "./forecast.js";
// The vocabulary the plays' cues and evidence rows are written in: thresholds
// and small reads over a DayRead. Shared by every play, so a change here moves
// more than one play; a change to one play belongs in playbook.ts.
export const STREAK_SAVE_SHORTFALL_STEPS = 800;
export const GAP_CLOSEABLE_STEPS = 1200;
export const REENGAGE_QUIET_DAYS = 3;
export const PREP_MINUTES = 15;
export const BETWEEN_MINUTES = 10;
export const DECENT_GAP = { min: 20, max: 40 };
export const LATE_BREAK_MINUTES = 180;
export const EVENING_MINUTES = 17 * 60;
export const WORKOUT_SLOT_UNTIL = 15 * 60;
// A calendar shape alone is not a reason to speak; the member has to have been sitting through it.
export const seated = (r) => (r.body.idleMinutes ?? 0) >= r.seatedThreshold;
/** Overnight readings sitting off this member's own usual band. */
export const offUsual = (r) => r.body.readingsOffUsual ?? [];
/** How far under their own sleep target a night has to fall to count as short. */
export const SHORT_NIGHT_MARGIN_HOURS = 0.5;
/** How far over their own usual step count a day has to run to count as pushing. */
export const PUSHED_HARD_SHARE = 1.2;
/** Whether this member trains often enough for "today's workout" to be a thing they have. */
export const WORKOUT_ROUTINE_DAYS = 4;
/** Days off usual that make a run worth a heavier ask than any single day earns. */
export const SUSTAINED_DAYS = 3;
export const sustained = (r) => Math.max(runDays(r.body, "wearable.sleep", "below"), runDays(r.body, "wearable.hrv", "below")) >=
    SUSTAINED_DAYS;
export const trains = (r) => (r.body.workoutDays ?? 0) >= WORKOUT_ROUTINE_DAYS;
/** Nothing measured this member's body today, so the load has to speak for itself. */
export const noBodyRead = (r) => r.body.depletion === null;
/** The member said they are running low. Needs no device, so it is often the only read there is. */
export const REPORTED_STRAIN_HIGH = 0.6;
export const saidDepleted = (r) => (r.body.reportedStrain ?? 0) >= REPORTED_STRAIN_HIGH;
/** The days a weekly GLP-1 dose is most felt: the day itself and the day after. */
export const doseWindow = (r) => {
    const since = r.body.glp1?.daysSinceDose;
    return since != null && since <= 1;
};
export const glp1Reports = (r, effect) => r.body.glp1?.sideEffects.includes(effect) === true;
export const between = (r, from, to) => r.nowMinutes >= from && r.nowMinutes < to;
export const none = (n) => n == null || n === 0 ? "None yet" : n.toLocaleString("en-GB");
/** The gap between two meetings the member is standing in right now, if it is short. */
export function betweenRun(r) {
    const blocks = r.blocks ?? [];
    const justEnded = blocks.some((b) => b.endMinutes <= r.nowMinutes && r.nowMinutes - b.endMinutes <= BETWEEN_MINUTES);
    const next = blocks
        .filter((b) => b.startMinutes >= r.nowMinutes)
        .sort((a, b) => a.startMinutes - b.startMinutes)[0];
    return justEnded && next && next.startMinutes - r.nowMinutes <= BETWEEN_MINUTES
        ? { endsAt: next.startMinutes }
        : null;
}
export const gapAhead = (r) => r.nextGap && r.nextGap.startMinutes <= r.nowMinutes ? r.nextGap : null;
//# sourceMappingURL=arm-reads.js.map